/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, ButtonProps } from 'bold-ui'
import React, { useState } from 'react'

export interface StickyButtonProps extends ButtonProps {
  showsAt: number | 'bottom'
}

export function StickyButton(props: StickyButtonProps) {
  const { showsAt, ...rest } = props

  const [visible, isVisible] = useState(false)

  const styles = createStyles(visible)

  React.useEffect(() => {
    const listener = () => {
      const limit = showsAt === 'bottom' ? document.documentElement.scrollHeight - window.innerHeight : showsAt
      if (document.documentElement.scrollTop >= limit && !visible) {
        isVisible(true)
      } else if (document.documentElement.scrollTop < limit && visible) {
        isVisible(false)
      }
    }

    window.addEventListener('scroll', listener)

    return () => window.removeEventListener('scroll', listener)
  }, [showsAt, visible])

  return (
    <div css={styles.wrapper}>
      <Button {...rest} style={styles.button} />
    </div>
  )
}

const createStyles = (visible: boolean) => ({
  button: css`
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `,
  wrapper: css`
    display: ${visible ? 'block' : 'none'};
    position: fixed;
    bottom: 0;
    left: 50%;
  `,
})
